export enum ShowMessageCommandTypes {
  Hide = 0,
  Sud = 1,
  Voc = 2,
}
